/**
 * Handles edit navigation events by jumping to target locations in the document.
 */
import { edit } from "../office/Edit";
import { dispatch } from "../utils/events";
import { pipeline } from "./updates";

document.addEventListener(
  "edit-target-received",
  async (e) => {
    dispatch("save-location");
    await edit(e.detail)
    if (Office.context.platform === Office.PlatformType.OfficeOnline) {
      pipeline.ignoreNextModification();
    }
  }
);
